var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _vm.documento.permisos_heredados
        ? _c("div", { staticClass: "card is-radiusless" }, [
            _c("div", { staticClass: "card-content is-radiusless py-3 px-4" }, [
              _c("p", { staticClass: "is-size-7" }, [
                _c("i", {
                  staticClass: "fas fa-info fa-fw fa-lg has-text-primary mr-3",
                }),
                _vm._v(_vm._s(_vm.getNombreFile()) + " "),
                _c("i", { class: _vm.getIconFile() }),
                _vm._v(" cuenta con permisos "),
                _c("b", [_vm._v("heredados")]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.documento.permisos_bloqueados &&
      _vm.documento.tipo_documento_id === "carpeta"
        ? _c("div", { staticClass: "card is-radiusless" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.documento.permisos, function (permiso, index) {
        return _c(
          "div",
          { key: `permiso-${index}`, staticClass: "card is-radiusless" },
          [
            _c(
              "div",
              {
                staticClass: "card-header is-radiusless",
                class: {
                  "has-background-warning-light":
                    _vm.isPermisoHeredado(permiso),
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "card-header-title is-400 is-flex-direction-row is-align-items-start is-justify-content-space-between pr-0",
                  },
                  [
                    _c("div", [
                      _vm.canEditPermisos
                        ? _c(
                            "a",
                            {
                              attrs: {
                                disabled:
                                  permiso.dependencia_id != null ||
                                  permiso.nivel == 9,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleModalConfirmDelete(permiso)
                                },
                              },
                            },
                            [_c("i", { staticClass: "fas fa-times-circle" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "ml-2" },
                        [
                          _c("i", {
                            staticClass: "fas fa-fw",
                            class: _vm.getTipoPermisoIcon(permiso),
                          }),
                          _vm._v(
                            "\n             " +
                              _vm._s(_vm.getSujetoPermiso(permiso)) +
                              "\n            "
                          ),
                          _vm.isPermisoHeredado(permiso)
                            ? _c(
                                "b-tooltip",
                                {
                                  attrs: {
                                    position: "is-right",
                                    type: "is-warning",
                                    label: permiso.modificado
                                      ? "El permiso heredado ha sido modificado"
                                      : "El permiso es heredado de un recurso superior",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "tag is-warning is-light is-rounded ml-2 is-unselectable",
                                    },
                                    [
                                      !permiso.modificado
                                        ? _c("i", {
                                            staticClass:
                                              "fas fa-level-down-alt fa-fw",
                                          })
                                        : _c("i", {
                                            staticClass:
                                              "fas fa-pencil-alt fa-fw",
                                          }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            permiso.modificado
                                              ? "Modificado"
                                              : "Heredado"
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "has-text-right" },
                      [
                        _c(
                          "span",
                          { staticClass: "is-size-7 is-unselectable" },
                          [
                            _vm._v("Nivel "),
                            _c("b", [_vm._v(_vm._s(permiso.nivel))]),
                          ]
                        ),
                        _vm._v(" \n               "),
                        _vm._l(9, function (nivelBoton) {
                          return _c(
                            "b-tooltip",
                            {
                              key: `permiso-${permiso.id}-nivelBoton-${nivelBoton}`,
                              attrs: {
                                label: `Nivel ${nivelBoton}`,
                                position: "is-left",
                                type: "is-info",
                                animated: false,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-lock fa-fw",
                                class: _vm.getColor(permiso, nivelBoton),
                                attrs: {
                                  disabled: _vm.isChangeNivelDisabled(
                                    permiso,
                                    nivelBoton
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeLevel(permiso, nivelBoton)
                                  },
                                },
                              }),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "card-header-icon",
                    on: {
                      click: function ($event) {
                        return _vm.openCollapse(index)
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fas fa-lg",
                      class:
                        _vm.isOpen === index ? "fa-angle-up" : "fa-angle-down",
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-collapse",
              { attrs: { open: _vm.isOpen === index, animation: "slide" } },
              [
                _c(
                  "div",
                  { staticClass: "card-content is-radiusless" },
                  [_c("ListadoPermisos", { attrs: { level: permiso.nivel } })],
                  1
                ),
              ]
            ),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.canEditPermisos
        ? _c("div", { staticClass: "card is-radiusless" }, [
            _c("div", { staticClass: "card-content is-radiusless p-3" }, [
              _c("div", { staticClass: "field is-grouped" }, [
                _c("div", { staticClass: "control is-expanded" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "button is-fullwidth is-outlined is-fullwdith is-small is-primary",
                      on: { click: _vm.openModalAgregarUsuario },
                    },
                    [
                      _c("i", { staticClass: "fas fa-user fa-fw" }),
                      _vm._v(" Agregar usuario\n            "),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "control is-expanded" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "button is-fullwidth is-outlined is-small is-primary",
                      on: { click: _vm.openModalAgregarArea },
                    },
                    [
                      _c("i", { staticClass: "fas fa-users fa-fw" }),
                      _vm._v(" Agregar area\n            "),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm.isOwnerDocumento
                  ? _c("div", { staticClass: "control is-expanded" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "button is-fullwidth is-outlined is-small is-primary",
                          on: { click: _vm.openModalCambiarPropietario },
                        },
                        [
                          _c("i", { staticClass: "fas fa-exchange-alt fa-fw" }),
                          _vm._v(" Cambiar propietario\n            "),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isOwnerDocumento
        ? _c(
            "div",
            { staticClass: "card is-radiusless" },
            [
              _c(
                "b-collapse",
                {
                  attrs: { open: _vm.isOpen === 10000, animation: "slide" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "trigger",
                        fn: function (props) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "card-header is-radiusless",
                                attrs: { role: "button" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "card-header-title is-flex-direction-row is-align-items-start is-justify-content-space-between",
                                  },
                                  [
                                    _vm._v(
                                      "\n                Opciones avanzadas\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "card-header-icon",
                                    on: {
                                      click: function ($event) {
                                        return _vm.openCollapse(10000)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-lg",
                                      class: props.open
                                        ? "fa-angle-up"
                                        : "fa-angle-down",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    948797535
                  ),
                },
                [
                  _vm._v(" "),
                  _c("div", { staticClass: "card-content" }, [
                    _c("div", { staticClass: "columns" }, [
                      _c("div", { staticClass: "column" }, [
                        _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Heredar permisos superiores"),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "is-size-7 mb-3" }, [
                            _vm._v("Al estar "),
                            _c("b", [_vm._v("activado")]),
                            _vm._v(
                              ", " +
                                _vm._s(_vm.getNombreFile().toLowerCase()) +
                                " "
                            ),
                            _c("i", { class: _vm.getIconFile() }),
                            _vm._v(
                              " heredará los permisos de la carpeta superior. Los permisos heredados pueden ser luego "
                            ),
                            _c("b", [_vm._v("modificados")]),
                            _vm._v(
                              " con otros niveles de permiso en caso de requerirlo"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "is-size-7 mb-3" }, [
                            _c("span", { staticClass: "has-text-danger" }, [
                              _c("i", {
                                staticClass: "fas fa-exclamation-triangle",
                              }),
                              _vm._v(" IMPORTANTE: "),
                            ]),
                            _vm._v("Solo el "),
                            _c("b", [_vm._v("propietario")]),
                            _vm._v(" "),
                            _c("i", { staticClass: "far fa-star" }),
                            _vm._v(" del recurso puede cambiar esta opción."),
                            !_vm.heredado
                              ? _c("span", [
                                  _vm._v(
                                    " Al activar la herencia, puede haber cambio de propietario. Los cambios de propietarios son "
                                  ),
                                  _c("b", [_vm._v("permanentes")]),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "control" },
                            [
                              _c(
                                "b-switch",
                                {
                                  attrs: {
                                    size: "is-small",
                                    type: _vm.showPosibleHerenciaForzada
                                      ? "is-danger"
                                      : null,
                                  },
                                  on: {
                                    input:
                                      _vm.openModalConfirmarHerenciaPermisos,
                                  },
                                  model: {
                                    value: _vm.heredado,
                                    callback: function ($$v) {
                                      _vm.heredado = $$v
                                    },
                                    expression: "heredado",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.heredado ? "Activado" : "Desactivado"
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.showPosibleHerenciaForzada
                            ? _c(
                                "p",
                                {
                                  staticClass: "is-size-7 mt-2 has-text-danger",
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-exclamation-triangle",
                                  }),
                                  _vm._v(
                                    " Error al cambiar la herencia de permisos. ¿Revisó si la carpeta contenedora de esta carpeta o documento está forzando la herencia?"
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.canBlockPermisos
                        ? _c("div", { staticClass: "column" }, [
                            _c("div", { staticClass: "field" }, [
                              _c("label", { staticClass: "label" }, [
                                _vm._v(
                                  "Forzar herencia de permisos hacia abajo"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "is-size-7 mb-3" }, [
                                _vm._v("Al estar "),
                                _c("b", [_vm._v("activado")]),
                                _vm._v(
                                  ", los documentos y carpetas dentro de " +
                                    _vm._s(_vm.getNombreFile().toLowerCase()) +
                                    " "
                                ),
                                _c("i", { class: _vm.getIconFile() }),
                                _vm._v(
                                  " heredaran los permisos por defecto y no podrá ser removida"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "is-size-7 mb-3" }, [
                                _vm._v("Solo el "),
                                _c("b", [_vm._v("propietario")]),
                                _vm._v(" "),
                                _c("i", { staticClass: "far fa-star" }),
                                _vm._v(
                                  " del recurso puede cambiar esta opción"
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "control" },
                                [
                                  _c(
                                    "b-switch",
                                    {
                                      attrs: { size: "is-small" },
                                      on: {
                                        input: _vm.openModalBloquearPermisos,
                                      },
                                      model: {
                                        value: _vm.blocked,
                                        callback: function ($$v) {
                                          _vm.blocked = $$v
                                        },
                                        expression: "blocked",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.blocked
                                            ? "Activado"
                                            : "Desactivado"
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-content is-radiusless py-3 px-4" }, [
      _c("p", { staticClass: "is-size-7" }, [
        _c("i", {
          staticClass: "fas fa-info fa-fw fa-lg has-text-primary mr-3",
        }),
        _vm._v("Se está forzando la herencia de permisos hacia abajo."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }